export default __webpack_public_path__ + "static/media/uploadIcon2.9b185b7b.svg";